var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1308_1290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.56689 24.7008C1.56572 28.9017 2.67197 33.0037 4.77549 36.6192L1.36572 48.9723L14.1063 45.6576C17.6303 47.561 21.5785 48.5584 25.5907 48.5587H25.6013C38.8464 48.5587 49.6282 37.8643 49.6339 24.7196C49.6364 18.35 47.1388 12.3605 42.6009 7.85427C38.0638 3.34845 32.0296 0.8657 25.6003 0.862793C12.3536 0.862793 1.57256 11.5566 1.56709 24.7008",
    fill: "url(#paint0_linear_1308_1290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.708984 24.693C0.707617 29.0452 1.85352 33.2938 4.03203 37.0388L0.5 49.8347L13.6975 46.4012C17.3338 48.3684 21.4279 49.4056 25.5939 49.4072H25.6047C39.325 49.4072 50.4941 38.3281 50.5 24.7128C50.5023 18.1143 47.9148 11.9095 43.2148 7.24186C38.5143 2.57481 32.2643 0.00271318 25.6047 0C11.882 0 0.714453 11.0775 0.708984 24.693ZM8.56855 36.3938L8.07578 35.6176C6.0043 32.3494 4.91094 28.5727 4.9125 24.6946C4.9168 13.3777 14.1988 4.17054 25.6125 4.17054C31.1398 4.17287 36.3344 6.31085 40.2414 10.1899C44.1482 14.0694 46.298 19.2264 46.2967 24.7112C46.2916 36.0281 37.0094 45.2364 25.6047 45.2364H25.5965C21.883 45.2345 18.241 44.245 15.0648 42.375L14.309 41.9302L6.47734 43.9676L8.56855 36.3938Z",
    fill: "url(#paint1_linear_1308_1290)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3823 14.3697C18.9163 13.3419 18.4259 13.3212 17.9827 13.3032C17.6198 13.2877 17.205 13.2888 16.7905 13.2888C16.3757 13.2888 15.7017 13.4437 15.1319 14.0609C14.5616 14.6788 12.9546 16.1718 12.9546 19.2084C12.9546 22.245 15.1837 25.1799 15.4944 25.5921C15.8056 26.0036 19.7978 32.4346 26.1204 34.9086C31.3751 36.9646 32.4444 36.5557 33.5849 36.4526C34.7255 36.3499 37.2653 34.96 37.7835 33.5187C38.302 32.0776 38.3021 30.8423 38.1466 30.5842C37.9911 30.327 37.5763 30.1726 36.9542 29.864C36.3321 29.5555 33.2737 28.0621 32.7036 27.8561C32.1333 27.6503 31.7187 27.5476 31.3038 28.1656C30.889 28.7826 29.6978 30.1726 29.3347 30.5842C28.972 30.9968 28.6089 31.0481 27.987 30.7394C27.3645 30.4297 25.3612 29.7788 22.9845 27.6762C21.1353 26.0402 19.8868 24.0198 19.5239 23.4018C19.161 22.7848 19.4851 22.4503 19.797 22.1427C20.0765 21.8662 20.4192 21.422 20.7306 21.0617C21.0407 20.7012 21.1442 20.4441 21.3517 20.0324C21.5593 19.6204 21.4554 19.26 21.3001 18.9512C21.1442 18.6425 19.9354 15.59 19.3823 14.3697Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1308_1290",
    x1: 2414.77,
    y1: 4811.81,
    x2: 2414.77,
    y2: 0.862793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1308_1290",
    x1: 2500.5,
    y1: 4983.47,
    x2: 2500.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1308_1290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/Whatsapp-icon.f61a021189a82385b73b93e9543bdaa3.svg";
export { ForwardRef as ReactComponent };